import React from 'react';
import IconButton from '../../v2BaseComponents/IconButton';

export type MobileChatsButtonOwnProps = {
    onPress: () => void;
};

export type MobileChatsButtonProps = MobileChatsButtonOwnProps;

const MobileChatsButton: React.FC<MobileChatsButtonProps> = ({ onPress }) => {
    return <IconButton icon="AISparkle" onPress={onPress} testID="ai-chat-button" variant="invert" />;
};

export default React.memo(MobileChatsButton);
